import './day-of-month';
import './day-of-week';
import './day-of-year';
import './hour';
import './minute';
import './month';
import './second';
import './week';
import './week-calendar-utils';
import './year';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-bootstrap/bs-moment/units/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/index.js
// module chunks = 4